"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfActivitySessionSearchModel = instanceOfActivitySessionSearchModel;
exports.ActivitySessionSearchModelFromJSON = ActivitySessionSearchModelFromJSON;
exports.ActivitySessionSearchModelFromJSONTyped = ActivitySessionSearchModelFromJSONTyped;
exports.ActivitySessionSearchModelToJSON = ActivitySessionSearchModelToJSON;
exports.ActivitySessionSearchModelToJSONTyped = ActivitySessionSearchModelToJSONTyped;
/**
 * Check if a given object implements the ActivitySessionSearchModel interface.
 */
function instanceOfActivitySessionSearchModel(value) {
    return true;
}
function ActivitySessionSearchModelFromJSON(json) {
    return ActivitySessionSearchModelFromJSONTyped(json, false);
}
function ActivitySessionSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'hourS': json['hourS'] == null ? undefined : json['hourS'],
    };
}
function ActivitySessionSearchModelToJSON(json) {
    return ActivitySessionSearchModelToJSONTyped(json, false);
}
function ActivitySessionSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'hourS': value['hourS'],
    };
}
